module.exports = __webpack_public_path__ + "img/sxsjs8.f63e7496.png";